import React from 'react'
import { Box, Typography, TextField, Chip, Button, useTheme } from '@mui/material'
import { ReactComponent as SearchIcon } from '../../../../../common/icons/search.svg'
import { CircularProgress } from '@mui/material'
import {
  searchInputStyles,
  chipContainerStyles,
  chipStyles,
  containedBottomButton,
  contentArea,
  footerArea,
  outlinedBottomButton,
  baseButtonStyles
} from './launchCampaignStyles'

const MIN_REQUIRED_TECHS = 5

export default function TechnologySelectionStep({
  allTechnologies,
  selectedTechnologies,
  onToggleTechnology,
  searchTerm,
  onSearchTermChange,
  onContinue,
  onBack,
  isSubmitting
}) {
  const theme = useTheme()

  const filteredTechnologies =
    !!allTechnologies?.length && allTechnologies?.filter(tech => tech.toLowerCase().includes(searchTerm.toLowerCase()))

  const canContinue = selectedTechnologies?.length >= MIN_REQUIRED_TECHS

  const selectedFilteredCount = filteredTechnologies.filter(tech =>
    selectedTechnologies.some(selected => selected === tech)
  ).length

  const isAllSelected = selectedFilteredCount === filteredTechnologies.length && filteredTechnologies.length > 0

  const handleToggleAll = () => {
    if (isAllSelected) {
      filteredTechnologies.forEach(tech => {
        const isSelected = selectedTechnologies.some(selected => selected === tech)
        if (isSelected) {
          onToggleTechnology(tech)
        }
      })
    } else {
      filteredTechnologies.forEach(tech => {
        const isSelected = selectedTechnologies.some(selected => selected === tech)
        if (!isSelected) {
          onToggleTechnology(tech)
        }
      })
    }
  }

  const toggleButtonStyles = {
    ...baseButtonStyles,
    width: 'auto',
    minWidth: '120px',
    color: '#1B1B26',
    backgroundColor: '#fff',
    border: '1px solid #D0D0D8',
    '&:hover': {
      backgroundColor: '#D0D0D8'
    }
  }

  return (
    <>
      <Box sx={{ mb: 0.5 }}>
        <Typography variant='h6' gutterBottom sx={{ mb: 1, fontWeight: '600' }}>
          Tailor training to your organization
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
          By default, all services are selected. You can disable any service at any time.
        </Typography>
      </Box>

      <TextField
        fullWidth
        variant='outlined'
        placeholder='Search services'
        value={searchTerm}
        onChange={onSearchTermChange}
        sx={searchInputStyles}
        InputProps={{
          endAdornment: <SearchIcon color='action' />
        }}
      />

      {filteredTechnologies.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mt: 1 }}>
          <Button variant='outlined' size='small' onClick={handleToggleAll} sx={toggleButtonStyles}>
            {isAllSelected ? 'Unselect All' : 'Select All'}
          </Button>
        </Box>
      )}

      <Box sx={contentArea}>
        <Box sx={chipContainerStyles}>
          {filteredTechnologies.map(tech => {
            const isSelected = selectedTechnologies.some(selected => selected === tech)
            return (
              <Chip
                key={tech}
                label={tech}
                clickable
                onClick={() => onToggleTechnology(tech)}
                color={isSelected ? 'primary' : 'default'}
                variant={isSelected ? 'filled' : 'outlined'}
                sx={chipStyles(isSelected)}
              />
            )
          })}
          {filteredTechnologies.length === 0 && searchTerm && (
            <Typography variant='body2' color='text.secondary' sx={{ p: 2, width: '100%', textAlign: 'center' }}>
              No services found for "{searchTerm}".
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={footerArea(theme)}>
        <Box width={'50%'}>
          <Button variant='outlined' onClick={onBack} sx={outlinedBottomButton}>
            Back
          </Button>
        </Box>
        <Box width={'50%'}>
          <Button
            variant='contained'
            onClick={onContinue}
            disabled={!canContinue || isSubmitting}
            sx={containedBottomButton}
            endIcon={isSubmitting && <CircularProgress size={16} />}
          >
            {selectedTechnologies.length < 5
              ? `Continue(${selectedTechnologies.length}/${MIN_REQUIRED_TECHS})`
              : `Continue (${selectedTechnologies.length})`}
          </Button>
        </Box>
      </Box>
    </>
  )
}
